export default __webpack_public_path__ + "static/media/A0001.49ecce24.png";